export default __webpack_public_path__ + "static/media/logo.ae7ca485.svg";